import Script from "next/script";
import { useEffect, useState } from "react";
import { useWebTranslation } from "translations";
import { getSocialLadderSettings } from "utils/site";

export const SocialLadderLogin = () => {
  useWebTranslation();
  const [isMounted, setIsMounted] = useState(false);
  const areaGuid = getSocialLadderSettings()?.areaGuid;
  const { i18n } = useWebTranslation();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted || !areaGuid) {
    return null;
  }

  return (
    <>
      <div id="slWebFrame"></div>
      <Script
        src="https://socialladder.rkiapps.com/SLWeb/slweb-frame.js"
        strategy="afterInteractive"
        onLoad={() => {
          const campGuid =
            (window as any).getParameterFromURLByName?.("campGuid") || "";
          const resGuid =
            (window as any).getParameterFromURLByName?.("resGuid") || "";
          var resetToken = (window as any).getParameterFromURLByName(
            "resetToken"
          );

          (window as any).loadSLWebFrame(
            areaGuid,
            "",
            campGuid,
            resGuid,
            resetToken,
            i18n?.language
          );
        }}
      />
    </>
  );
};
